const SCATTER = [[18, 30], [70, 18], [40, 62], [96, 50], [22, 96], [80, 92], [52, 120], [100, 128]];
const FOCUS = [[24, 40], [60, 80], [96, 120]];

const Route = ({ points, color, dashed, label, sub, testId }) => {
  const d = points.map(([x, y], i) => `${i ? "L" : "M"}${x} ${y}`).join(" ");
  return (
    <div className="flex-1 rounded-2xl border border-neutral-200 bg-white p-4" data-testid={testId}>
      <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-neutral-500">{label}</p>
      <svg viewBox="0 0 120 150" className="mt-2 h-36 w-full" aria-hidden="true">
        <path d={d} fill="none" stroke={color} strokeWidth="1.6" className={dashed ? "route-dash" : "route-draw"} strokeLinecap="round" strokeLinejoin="round" />
        {points.map(([x, y], i) => (
          <circle key={i} cx={x} cy={y} r="4.2" fill="#fff" stroke={color} strokeWidth="1.8" />
        ))}
      </svg>
      <p className="font-display text-lg leading-tight text-[#1f2328]">{sub}</p>
    </div>
  );
};

export const RouteCompare = () => (
  <div className="mt-8">
    <div className="flex gap-3">
      <Route points={SCATTER} color="#9ca3af" dashed label="Without MatchMaking" sub="8 scattered visits" testId="compare-without" />
      <Route points={FOCUS} color="#138808" label="With MatchMaking" sub="2–3 focused visits" testId="compare-with" />
    </div>
    <p className="mt-3 text-[11px] text-neutral-500">Illustrative numbers. Actual visits depend on your needs.</p>
  </div>
);
